<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevaGarita()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregarGarita}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'abrirModalGregarGarita'"
                [idClose]="'cerrarModalAgregarGarita'" [innTemplate]="abrirModalAgregarGarita"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalAgregarGarita>
  <div class="container-fluid">
    <form [formGroup]="agregarGaritaForm" mat-dialog-content>
      <div *ngIf="!isCreate" class="mb-2">
        <label for="">Garita N#</label>
        <input class="form-control" formControlName="idGarita" name="idGarita" type="text">
        <small *ngIf="descaControl?.hasError('idGarita') && descaControl.touched" class="text-danger">*Este campo es
          requerido</small>
      </div>
      <div class="mb-2">
        <label for="">Descripción</label>
        <input autocomplete="off" class="form-control" formControlName="desca" name="desca" type="text">
        <small *ngIf="descaControl?.hasError('required') && descaControl.touched" class="text-danger">*Este
          campo es
          requerido</small>
        <small *ngIf="descaControl?.hasError('maxlength') && descaControl.touched" class="text-danger">*Máximo 30
          caracteres</small>
      </div>
      <div class="mb-2">
        <label for="">Estado</label>
        <select class="form-control" formControlName="estado" name="estado">
          <option value="">-- Seleccione --</option>
          <option value="0">Activo</option>
          <option value="1">Inactivo</option>
        </select>
        <small *ngIf="descaControl?.hasError('estadoControl')" class="text-danger">*Este campo es requerido</small>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarGaritaForm.invalid"
                                   [loading]="loading" [textBoton]="'Guardar'"
                                   class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
